import axios from 'axios';

export default axios.create({
  baseURL: `${process.env.PORTAL_DOMAIN}/api`,
  timeout: 20000,
  withCredentials: true,
});
